import React, { useState, useContext } from 'react';
import {
    IonContent,
    IonPage,
    IonFab,
    IonFabButton,
    IonFabList, IonItem, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonItemOptions,
} from "@ionic/react";
import {
    Table,
    Menu,
    IconButton,
    toaster,
    SideSheet,
    Pane,
    Heading,
    Paragraph,
    Textarea,
    PhoneIcon,
    TextInputField,
    Button,
    Icon,
    TrashIcon,
    AddIcon,
    EditIcon,
    RefreshIcon,
    ResetIcon,
    ChatIcon,
    PlusIcon,
    Spinner,
    Dialog,
    EyeOpenIcon
} from 'evergreen-ui';
import Row from 'react-bootstrap/Row';
import moment from 'moment';
import { globalContext } from "../global/Store";
import MilestoneData from "./Milestones/MilestoneData";

const CaseMilestone = (props: any) => {

    const { globalState, dispatch, globalFunctions } = useContext(globalContext);
    const [selectedCase, setSelectedCase] = useState(props.case);
    const [selectedMilestone, setSelectedMilestone] = useState(null);
    const [showAddForm, setSehowAddForm] = useState(false);

    const handleEdit = (_selected: any) => {
        setSelectedMilestone(_selected);
        setSehowAddForm(true);
        console.log("Clicked");
    }

    const renderDates = (_milestone: any) => {

        if (JSON.parse(_milestone.milestoneData) !== null) {

            const _description = globalState.milestoneTypes.find((e: any) => e.id === _milestone.milestoneTypeId)?.description;

            if (_description === "Qualification") {
                return <p style={{ marginBottom: '0px' }}>Date Qualified: {JSON.parse(_milestone.milestoneData).qualifiedDate === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).qualifiedDate).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Decision in Principle") {
                return <p style={{ marginBottom: '0px' }}>Date Received: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Reservation") {
                return <p style={{ marginBottom: '0px' }}>Date Reserved: {JSON.parse(_milestone.milestoneData).dateReserved === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateReserved).format("DD/MM/YYYY")}</p>
            }
            if (_description === "PIF") {
                return <p style={{ marginBottom: '0px' }}>Date Received: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "ATP") {
                return <p style={{ marginBottom: '0px' }}>Date Received: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Mortgage Application") {
                return <p style={{ marginBottom: '0px' }}>Date Submitted: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Valuation Instructed") {
                return <p style={{ marginBottom: '0px' }}>Date Instructed: {JSON.parse(_milestone.milestoneData).dateInstructed === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateInstructed).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Valuation Booked") {
                return <p style={{ marginBottom: '0px' }}>Date Booked: {JSON.parse(_milestone.milestoneData).valuationBookedDate === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).valuationBookedDate).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Mortgage Agreed") {
                return <p style={{ marginBottom: '0px' }}>Date Received: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Mortgage Offered") {
                return <p style={{ marginBottom: '0px' }}>Date Offered: {JSON.parse(_milestone.milestoneData).dateCompleted === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).dateCompleted).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Offer Expiry") {
                return <p style={{ marginBottom: '0px' }}>Date of Expiry: {JSON.parse(_milestone.milestoneData).offerExpiryDate === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).offerExpiryDate).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Exchanged") {
                return <p style={{ marginBottom: '0px' }}>Date Exchanged: {JSON.parse(_milestone.milestoneData).exchangedDate === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).exchangedDate).format("DD/MM/YYYY")}</p>
            }
            if (_description === "Completion") {
                return <p style={{ marginBottom: '0px' }}>Date of Completion: {JSON.parse(_milestone.milestoneData).completionDate === undefined ? " - " : moment(JSON.parse(_milestone.milestoneData).completionDate).format("DD/MM/YYYY")}</p>
            }
        }
    }

    const getBackgroundColour = (_milestone: any) => {

        const sysDate = moment();

        if (_milestone.milestoneTypeId === 24 || _milestone.milestoneTypeId === 17) {


            const expiryDate = _milestone.offerExpiryDate !== undefined ?
                (globalState.milestoneTypes.find((e: any) => e.id === _milestone.milestoneTypeId)?.description) === "Offer Expiry" ? JSON.parse(_milestone.milestoneData) === null ? (_milestone.offerExpiryDate) :
                    JSON.parse(_milestone.milestoneData).offerExpiryDate : "0001-01-01T00:00:00"
                : "0001-01-01T00:00:00";

            if (_milestone.milestoneData !== null) {
                if (JSON.parse(_milestone.milestoneData).isMilestoneComplete !== 1) {
                    if (moment(expiryDate).format("DD/MM/YYYY") !== "01/01/0001") {
                        if (sysDate.diff(expiryDate, 'days') > 28)
                            return 'rgba(250, 0, 30, 0.2)'
                    }
                }
            } else {
                if (moment(expiryDate).format("DD/MM/YYYY") !== "01/01/0001") {
                    if (sysDate.diff(expiryDate, 'days') > 28)
                        return 'rgba(250, 0, 30, 0.2)'
                }
            }
        }

        //if (_milestone.milestoneType.description === "Qualification") {
        if (moment(_milestone.milestoneDate).format("DD/MM/YYYY") !== "01/01/0001") {
            return "#b6d7a8";
        }

        //Get Mortgage Application milestone
        var _mortgApp = props.case.milestones.filter((m: any) => m.milestoneTypeId === 21 || m.milestoneTypeId === 14)[0];

        //Mortgage Offered
        if (_milestone.milestoneTypeId === 75 || _milestone.milestoneTypeId === 79) {
            if (JSON.parse(_milestone.milestoneData) !== null) {
                if (JSON.parse(_milestone.milestoneData).isMilestoneComplete !== 1) {
                    if (JSON.parse(_mortgApp.milestoneData) !== null) {
                        if (sysDate.diff(JSON.parse(_mortgApp.milestoneData).dateCompleted, 'days') >= 28) {
                            return 'rgba(250, 0, 30, 0.2)'
                        }
                    }
                }
            } else {
                if (JSON.parse(_mortgApp.milestoneData) !== null) {
                    if (sysDate.diff(JSON.parse(_mortgApp.milestoneData).dateCompleted, 'days') >= 28) {
                        return 'rgba(250, 0, 30, 0.2)'
                    }
                }
            }
        }

    }

    const resetSelectedMilsetone = () => {
        setSelectedMilestone(null);
    }

    if (selectedCase == null) {
        return null;
    } else {
        const items = selectedCase.milestones;     /// selectedCase.caseMilestones.sort((a: any , b: any) => (a.milestoneType.order > b.milestoneType.order) ? 1 : ((b.milestoneType.order > a.milestoneType.order) ? -1 : 0))
        console.log("Milestones");
        console.log(items);

        return (
            <Pane>
                {items !== undefined && items.length > 0 ?
                    <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                        <Table style={{ width: '100%' }}>
                            <Table.Body>

                                {items.map((_milestone: any, index: any) => (
                                    <Table.Row key={index} style={{ height: 'auto', background: getBackgroundColour(_milestone) }}>
                                        {JSON.parse(_milestone.milestoneData) !== null ?
                                            JSON.parse(_milestone.milestoneData).isMilestoneComplete ? <Table.Cell
                                                //intent="success" 
                                                width={60} flex="none" style={{ background: '#52BD95', fontSize: '10px', borderCollapse: 'collapse', border: '5px', padding: '9px', color: 'white' }}>Complete</Table.Cell> :
                                                JSON.parse(_milestone.milestoneData).isQualifiedNo ? <Table.Cell
                                                    //intent="success" 
                                                    width={60} flex="none" style={{ background: '#ff2929' }}></Table.Cell> :
                                                    null
                                            : null}

                                        <Table.TextCell>
                                            <div style={{ padding: '20px' }}>
                                                <p style={{ fontSize: "15px", fontWeight: 'bold' }}>Milestone Stage: {

                                                    globalState.milestoneTypes.find((e: any) => e.id === _milestone.milestoneTypeId)?.description

                                                    // _milestone.milestoneTypeId.description
                                                }</p>
                                                {renderDates(_milestone)}
                                            </div>
                                        </Table.TextCell>
                                        <Table.Cell width={48} flex="none" style={{ background: 'white', borderLeft: '1px solid lightgray' }} onClick={() => handleEdit(_milestone)}>
                                            <IconButton icon={EyeOpenIcon} height={24} appearance="minimal" />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}

                            </Table.Body>
                        </Table>
                    </Row>
                    :
                    <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', padding: '20px', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                        <Heading style={{ paddingLeft: '20px' }}>No Milestone Data available</Heading>
                    </Row>}
                {selectedMilestone !== null ? <MilestoneData
                    resetSelectedMilsetone={() => resetSelectedMilsetone()}
                    selectedCase={selectedCase} selectedMilestone={selectedMilestone}
                >
                </MilestoneData> : null}
            </Pane>
        );
    }

}

export default CaseMilestone 